import { useSEO } from "../components/SEO";
import { PageHero, Reveal } from "../components/Reveal";
import { CaseStudyGrid } from "../components/CaseStudyPlaceholder";
import { CtaBand } from "../components/CtaBand";

export default function CaseStudies() {
  useSEO(
    "Case Studies | Nexus Catalyst Agency",
    "Documented Hajj & Umrah marketing campaigns: coming soon. Real strategies, campaign data and lessons learned, published only when verified."
  );

  return (
    <main data-testid="case-studies-page">
      <PageHero
        tag="Case Studies"
        testid="case-studies-hero"
        crumbs={[{ label: "Case Studies", to: "/case-studies" }]}
        lines={[
          "Case studies",
          <span className="text-tan">coming soon.</span>,
        ]}
        copy="We're building a portfolio of documented Hajj & Umrah marketing campaigns. As verified campaigns go live, this section will showcase real strategies, campaign data and lessons learned."
      />

      <section className="bg-cream py-20 md:py-28" data-testid="case-studies-grid-section">
        <div className="max-w-7xl mx-auto px-6">
          <CaseStudyGrid />
          <Reveal delay={0.2}>
            <div className="mt-12 border border-gold/30 bg-white p-6 md:p-8" data-testid="case-studies-honesty-note">
              <p className="text-sm text-charcoal/70 leading-relaxed max-w-3xl">
                No invented metrics, no stock testimonials, no borrowed logos.
                When Nexus Catalyst publishes results, they will be verified,
                permissioned and real. Until then, we'd rather show you an
                honest placeholder than a polished fiction.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <CtaBand
        title="Be the First Case Study Worth Publishing."
        copy="If your agency is ready to invest in a real acquisition system, let's talk about what a documented campaign could look like."
        testid="case-studies-cta-band"
      />
    </main>
  );
}
